import type { ContentStep } from '@cfa/pathway-fe-shared/xp';

import { getStepResource } from '@/utils/contentStep';

/** First content reference on a plan step's resource (document, game, etc.). */
export const getPlanStepResourceReference = (step: ContentStep | undefined) =>
  getStepResource(step)?.references?.[0];
